module.exports = __webpack_public_path__ + "img/商户API证书序列号.5501cdaf.png";